var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { prefixValue } from '../../common/utils/_.utils';
var PanelContainer = /** @class */ (function (_super) {
    __extends(PanelContainer, _super);
    function PanelContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelContainer.prototype.elementRender = function (def) {
        var _a = def.frontOptions, alignH = _a.alignH, alignV = _a.alignV, className = _a.className, style = _a.style;
        return React.createElement("div", { className: ['p-fluid p-grid' + prefixValue(alignV, ' ') + prefixValue(alignH, ' '), className].join(' '), style: style }, this.renderChildren());
    };
    return PanelContainer;
}(FormBaseElement));
export { PanelContainer };
//# sourceMappingURL=Panel.js.map